export default theme => ({
  root: () => ({}),
  localesSwitcher: () => ({
    color: theme.palette.common.white,
  }),
  loaderContainer: () => ({
    width: '35px',
  }),
  loader: () => ({
    color: 'inherit',
  }),
});
